import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../shared/services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthLeftPanelComponent } from "../../shared/components/auth-left-panel/auth-left-panel.component";
import { UnauthorizedLayoutComponent } from "../../shared/components/unauthorized-layout/unauthorized-layout.component";

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    TranslateModule,
    AuthLeftPanelComponent,
    UnauthorizedLayoutComponent
]
})
export class LoginComponent implements OnInit, OnDestroy {
  form: FormGroup;
  isLoading = false;
  errorMessage: string | null = null;
  showPassword = false;
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService
  ) {
    this.form = this.fb.group({
      usernameOrEmail: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false]
    });
  }

  ngOnInit(): void {
    // Clear any previous error when component initializes
    this.authService.clearError();

    // Subscribe to auth state to track loading
    this.authService.authState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.isLoading = state.loading;
        this.errorMessage = state.error;
      });

    // If already logged in, redirect to file-management
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/file-management']);
    }
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.errorMessage = null;
    const { usernameOrEmail, password } = this.form.value;

    this.authService.login({
      username: usernameOrEmail,
      password: password
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (user) => {
          console.log('Login successful:', user);
          // Check for return URL and redirect
          const returnUrl = sessionStorage.getItem('returnUrl');
          sessionStorage.removeItem('returnUrl');
          this.router.navigate([returnUrl || '/dashboard']);
        },
        error: (error) => {
          console.error('Login failed:', error);
          // Display the actual error message from the service
          let errorMsg = error.message || 'Login failed. Please try again.';
          this.errorMessage = errorMsg;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

